// Shared cookie read/write helpers on the _cc namespace.

(function () {

    const YEAR_SECONDS = 365 * 24 * 60 * 60;

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    // No `secure` — dev runs on plain http and the flag would drop the cookie there.
    function setCookie(name, value, maxAgeSeconds) {
        const maxAge = maxAgeSeconds === undefined ? YEAR_SECONDS : maxAgeSeconds;
        document.cookie = name + '=' + encodeURIComponent(value)
            + '; path=/; max-age=' + maxAge + '; samesite=Lax';
    }

    window._cc = window._cc || {};
    window._cc.getCookie = getCookie;
    window._cc.setCookie = setCookie;

})();
